'use client';

import React, { useEffect, useState } from 'react';
import { css, cx } from 'styled-system/css';

export function FancyBorder({ snippet }: { snippet: string }) {
  const [uiLoading, setUiLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setUiLoading(false);
    }, 0);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      <style>{snippet}</style>
      <div
        className={cx(
          'animated-border-parent',
          css({
            m: '4',
            display: 'flex',
            h: '80',
            w: '80',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 'sm',
            p: '2px',
          }),
        )}
      >
        <div
          className={cx(
            'animated-border-bg',
            css({ borderRadius: 'lg' }),
            !uiLoading && css({ opacity: '1!' }),
          )}
        />
        <div
          className={css({
            position: 'relative',
            zIndex: '10',
            display: 'flex',
            h: 'full',
            w: 'full',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 'lg',
            bg: '#0f172a',
            color: 'white',
          })}
        >
          Content
        </div>
      </div>
    </div>
  );
}
